








































































































































































import _, { keyBy } from "lodash";
import { UIModel } from "../../UIModel";
import { Prop, Component, Vue } from "vue-property-decorator";
import { FrontendBIM360Issue } from "@/model/frontend/FrontendBIM360Issue";
import { FrontendBIM360IssueActivity } from "@/model/frontend/FrontendBIM360IssueActivity";
import { BIM360IssueActivityType } from "@/model/BIM360IssueActivity";
import { NGIssueTypeV2 } from "@/model/BIM360NGIssueTypeV2";
import { ExportToCsv } from './../../util/ExportToCsv';
import download from "downloadjs";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { BIM360IssueAttributeDefinition } from '@/model/BIM360IssueAttributeDefinition';
import { BIM360AttributeOption } from '@/model/BIM360AttributeOption';
import { FrontendBIM360IssueActivityV2 } from '@/model/frontend/FrontendBIM360IssueActivityV2';


@Component
export default class IssueModal extends Vue {
	// Props
	@Prop({ required: true }) public model!: UIModel;
	@Prop({ required: true }) public issue!: FrontendBIM360Issue;
	
	// Data
	public isOpen: boolean = false;
	public loadingActivities: boolean = false;
	public activities: FrontendBIM360IssueActivityV2[] = [];
	public issueActivityHistoryJSON: string | null = null;
	public issueActivityHistoryPDF: any | null = null;
	public exportISLoading: boolean = false;

	// Getters
	get isMobile(): boolean {
		if (window) {
			return window.innerWidth < 768;
		} else {
			return false;
		}
	}

	getActivityDate(activity: any): Date {
		const date = activity?.submitted || activity?.activity?.published;
		return new Date(date);
	}

	// get visible_activities(): any[] {
	// 	if (this.activities.length > 0) {
	// 		return this.activities.filter((activity) => {
	// 			for (var activity_group of activity.activities) {
	// 				if (activity_group.type != BIM360IssueActivityType.VIEW) {
	// 					return true;
	// 				}
	// 			}
	// 			return false;
	// 		});
	// 	} else {
	// 		return [];
	// 	}
	// }

	get visible_activities(): any[] {
		if (this.activities.length > 0) {
			const a = this.activities.filter((activity) => activity.activity.verb != BIM360IssueActivityType.VIEW);
			return a
		} else {
			return [];
		}
	}

	get issueActivityHistoryJSONName(): string {
		return `issue-#${this.issue.id}-activity-history-${this.$options?.filters?.fileDate(new Date())}.json`;
	}

	get issueActivityHistoryPDFName(): string {
		return `issue-#${this.issue.id}-activity-history-${this.$options?.filters?.fileDate(new Date())}.pdf`;
	}

	// Created
	public created() {
		
	}

	// Mounted
	public mounted() {
        
	}

	// Methods
	public getCustomAttributeChanges(change: any): any[] {
		return change.property == 'custom_attributes' ? change.after : [];
	}

	public getChangeValue(change: any): any {
		if (change.value == null) {
			return '';
		} else if (change.type != 'list') {
			// If the custom attribute is a not a list attribute, return the value
			return change.value;
		} else {
			// Look up the attribute definition and retrieve the value from that
			let attributeDefinition = this.model.issueAttributeDefinitions.find((definition: BIM360IssueAttributeDefinition) => {
				return definition.title == change.title;
			});

			if (!attributeDefinition) {
				return 'Could not find attribute definition. Please contact support.';
			} else {
				// Find the selected option and return the value
				let selectedOption = attributeDefinition.options.find((option: BIM360AttributeOption) => {
					return option.id == change.value;
				});
				return selectedOption ? selectedOption.value : 'Could not find selected option. Please contact support';
			}
		}
	}

	public formatCommentWithMentions(comment: string): string {
		const regex = /@(?<json>\{[^}]*\})/gm;
		return comment.replace(regex, (match, mentionJson) => {
			try {
				const mention = JSON.parse(mentionJson);

				if (!mention.name) {
					return match;
				}

				return `<b>@${mention.name}</b>`;
			} catch (error) {
				try {
					const repairedJson = mentionJson.replace(
						/\\(?!["\\/bfnrtu])/g,
						"\\\\"
					);
					const mention = JSON.parse(repairedJson);
					if (!mention.name) {
						return match;
					}
					return `<b>@${mention.name}</b>`;
				} catch (repairError) {
					console.error("Invalid mention JSON:", mentionJson, error);
					return match;
				}
			}
		});
	}


	public async getIssueActivities(): Promise<void> {
		if (this.model.selectedProject) {
			this.loadingActivities = true;
			this.activities = await this.model.getIssueActivities(this.issue, this.model.selectedProject);
			this.loadingActivities = false;
		}
	}

	// public getVisibleActivities(activity: FrontendBIM360IssueActivity): any {
	// 	return activity.activities.filter((change: any) => {
	// 		return change.type != BIM360IssueActivityType.VIEW;
	// 	});
	// }

	public open(): void {
        this.isOpen = true;
		this.getIssueActivities();
	}

	public cancel(): void {
		this.isOpen = false;
	}

	public getDate(date: string | Date | null | undefined): Date | null {
		return date ? new Date(date) : null;
	}

	public getUserName(name: string): string {
		if (this.model.projectUsers && this.model.projectUsers[name]) {
			return this.model.projectUsers[name].name;
		} else if (this.model.projectRoles && this.model.projectRoles[name]) {
			return this.model.projectRoles[name].name;
		} else {
			return '';
		}
	}

	public getActivityType(type: string): string {
		switch(type) {
			case BIM360IssueActivityType.CREATE:
				return "Created the Issue";
			case BIM360IssueActivityType.VIEW:
				return "Viewed the Issue";
			case BIM360IssueActivityType.ATTACH:
				return "Added an Attachment";
			case BIM360IssueActivityType.COMMENT:
				return "Added a Comment";
			case BIM360IssueActivityType.OPEN:
				return "Opened the Issue";
			case BIM360IssueActivityType.CLOSED:
				return "Closed the Issue";
			case BIM360IssueActivityType.ANSWERED:
				return "Answered the Issue";
			case BIM360IssueActivityType.ASSIGN:
				return "Assigned the Issue";
			case BIM360IssueActivityType.VOID:
				return "Voided the Issue";
			case BIM360IssueActivityType.DUE_DATE:
				return "Changed the Due Date";
			case BIM360IssueActivityType.EDIT:
				return "Modified the Issue";
			default:
				return '';
		}
	}

	public getTagType(status: string): string {
		switch (status) {
			case "void":
			case "closed":
			case "draft":
				return "is-light";
			case "open":
				return "is-warning";
			case "answered":
				return "is-info";
			default: 
				return '';
		}
	}

	public getIssueType(type: string): string {
		return this.model.projectNGIssueTypesDict ? this.model.projectNGIssueTypesDict[type]?.title : '';
	}

	public getIssueSubType(type: string): string {
		let issue_type = this.model.projectNGIssueTypesDict[type];

		if (!issue_type) {
			return '';
		} else {
			if (issue_type.isSubType && issue_type.id == type) {
				return issue_type.title;
			}

			let target = issue_type.subtypes.find((subtype: NGIssueTypeV2) => {
				return subtype.id == type;
			});
			return target ? target.title : '';
		}		
	}

	public getChangeString(type: string, value: any): string | Date | null {
		switch (type) {
			case "status":
				return value ? `${value[0].toUpperCase()}${value.substring(1)}` : '';
			case "issue_type_id":
				return this.getIssueType(value);
			case "issue_subtype_id":
				return this.getIssueSubType(value);
			case "assigned_to":
				return this.getUserName(value);
			case "due_date":
				return this.$options?.filters?.shortDate(this.getDate(value));
			case "owner":
				return this.getUserName(value);
			case "custom_attributes":
			case "name":
			case "title":
			case "description":
			case "body":
			case "comment":
			default:
				return value;
		}
	}

	getRootCauseName(id: string)
    {
        const extractedArrays = _.map(this.model.projectRootCauseCategories, 'rootCauses');
        const allRootCauses = _.flatten(extractedArrays);
        const rc = allRootCauses.find(c => c.id == id);
        if(rc)return rc.title;
        return "";
    }

	public getChangeLabel(type: string): string {
		switch (type) {
			case "status":
				return "Status";
			case "issue_type_id":
				return "Type";
			case "issue_subtype_id":
				return "Subtype";
			case "assigned_to":
				return "Assigned To";
			case "due_date":
				return "Due Date";
			case "owner":
				return "Owner";
			case "name":
				return "Name";
			case "title":
				return "Title";
			case "description":
				return "Description";
			case "body":
				return "Comment";
			default:
				return '';
		}
	}

	public exportToJSON(): void {
		let all_activities = this.activities.map((activity) => ({
			id: activity.id,
			date: activity?.submitted || activity?.activity?.published,
			user: this.getUserName(activity.activity.actor.id),
			type: activity.activity.verb,
			changes: activity.getChanges().map((change: any) => {
				return {
					property: change.property,
					before: this.getChangeString(change.property, change.before),
					after: this.getChangeString(change.property, change.after)
				}
			})
		}));
		download("data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(all_activities)), this.issueActivityHistoryJSONName, "application/json");
	}

	public exportToCSV(): void {
		const formatted_date = this.$options?.filters?.fileDate(new Date());
		let reformatted_data: any[] = [];

		for (var activity of this.activities) {
			reformatted_data.push({
				Date: new Date(activity.submitted || activity.activity?.published).toLocaleString("en-NZ"),
				User: this.getUserName(activity.activity.actor.id),
				Changes: this.getActivityType(activity.type),
				Property: "",
				From: "",
				To: ""
			});



			for (var change of activity.getChanges()) {
				if (change.property == "custom_attributes") {
					for (var index in (change as any).after) {
						reformatted_data.push({
							Date: "",
							User: "",
							Changes: "",
							Property: `${change.after[index].title} (Custom Attribute)`,
							From: this.getChangeString(change.property, change.before[index].value),
							To: this.getChangeString(change.property, change.after[index].value)
						});
					}
				}

				if (this.getChangeLabel(change.property) != '') {
					reformatted_data.push({
						Date: "",
						User: "",
						Changes: "",
						Property: this.getChangeLabel(change.property),
						From: this.getChangeString(change.property, change.before),
						To: this.getChangeString(change.property, change.after)
					});
				}
			}
			
		}

		const options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true, 
            showTitle: true,
            title: `Issue #${this.issue.id} Activity History`,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            filename: `issue-#${this.issue.id}-activity-history-${formatted_date}`
            // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(JSON.parse(JSON.stringify(reformatted_data)));
	}

	public async exportToPDF(): Promise<void> {
		// Load HTML
		this.exportISLoading = true;

		let element: HTMLElement = document.getElementById("activity-history-modal")?.getElementsByClassName("card-content")[0].childNodes[0] as HTMLElement;
		if (element == undefined) {
			throw new Error("Could not find target div!");
		}

		let icons: HTMLCollection = element.getElementsByClassName("icon");
		for (var icon of icons) {
			(icon as any).style.display = "none";
			(icon as any).nextElementSibling.style.display = "block";
		}

		html2canvas(element).then((canvas) => {
			let options = {
				margin: 20,
				filename: this.issueActivityHistoryPDFName,
				html2canvas: {
					useCORS: true
				},
				pagebreak: { mode: "avoid-all" }
			};
			html2pdf().set(options).from(canvas).save();

			this.exportISLoading = false;
		});

		for (var icon of icons) {
			(icon as any).style.display = "flex";
			(icon as any).nextElementSibling.style.display = "none";
		}
	}
}
